/**
 * Search
 */

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from '../../../shared/dom/manipulator';
import EventHandler from '../../../shared/dom/event-handler';
import Data from '../../../shared/dom/data';

import Drawer from '../../../shared/components/drawer';

// -------
// Privat
// -------

const NAME      = 'search';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

let searchForm = null;
let searchField = null;
let searchFieldMin;

const setupSearchForm = () => {
	const submitButton = SelectorEngine.findOne('button[type="submit"]', searchForm);

	searchFieldMin = parseInt(searchField.getAttribute('min') ?? 0, 10);

	// Formular-Submit prüfen.
	EventHandler.on(searchForm, 'submit', event => {
		if (Data.get(searchForm, 'searchEnabled') !== true) {
			event.preventDefault();
			event.stopPropagation();
		}
	});

	// Formular prüfen auf aktiv oder inaktiv.
	EventHandler.on(searchForm, 'search.handleSubmit', () => {
		if (searchField.value !== '' && searchField.value.length >= searchFieldMin) {
			Data.set(searchForm, 'searchEnabled', true);
			Manipulator.setDisabled(submitButton, false);
		} else {
			Data.set(searchForm, 'searchEnabled', false);
			Manipulator.setDisabled(submitButton);
		}
	});

	// Eingabefeld: bei Eingabe Formular prüfen
	EventHandler.on(searchField, 'keyup', () => {
		EventHandler.trigger(searchForm, 'search.handleSubmit');
	});

	// Eingabefeld: wenn per Klick ´geleert´, dann Formular prüfen
	EventHandler.on(searchField, 'clearable.clear', () => {
		EventHandler.trigger(searchForm, 'search.handleSubmit');
	});

	// Formular prüfen
	EventHandler.trigger(searchForm, 'search.handleSubmit');
};

/**
 * Drawer ´Search´
 */
const setupDrawer = async () => {
	const ctrls = SelectorEngine.find('[aria-controls="search-drawer"]');
	const drawerContainer = SelectorEngine.findOne('#search-drawer');

	if (!drawerContainer) {
		for (const ctrl of ctrls) {
			Manipulator.setDisabled(ctrl, true);
		}

		return;
	}

	const drawerApi = new Drawer(drawerContainer, {
		closeButton: false,
		noHeader   : true,
		onShow     : function () {
			for (const ctrl of ctrls) {
				Manipulator.addClass(ctrl, '_active');
			}

			searchField.focus();
		},
		onHidden   : () => {
			for (const ctrl of ctrls) {
				Manipulator.removeClass(ctrl, '_active');
			}
		}
	});

	for (const ctrl of ctrls) {
		EventHandler.on(ctrl, `click${EVENT_KEY}`, (event) => {
			event.preventDefault();
			event.stopPropagation();

			if (event.delegateTarget.classList.contains('_active')) {
				drawerApi.hide();
			} else {
				if (window.drawer.menu) {
					window.drawer.next = drawerApi;
					window.drawer.menu.hide();
				} else {
					drawerApi.show();
				}
			}
		});
	}
};

// -------
// Public
// -------

const search = async () => {
	searchForm  = SelectorEngine.findOne('.search-box form');
	searchField = searchForm ? SelectorEngine.findOne('.search-box__input', searchForm) : null;

	if (searchField) {
		await setupSearchForm();
		await setupDrawer();
	}

	return searchForm;
};

// Export
export default search;
